import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import OutsideNotifier from './../../OutsideNotifier';
import config from './../../config';
import common from './../../common';
import {
    triggerHandleFixturePopup, triggerMixFetchData,
} from './../../actions/FormationActions';
import {
    getFixtures,
} from './../../actions/ManageTeamActions';
import {
    getFixturesToPrintForMatches, getFixtureStatus,
} from "./../../helper";
import {
    getMatchTimeObj,
} from "./../../helper-common";
import { find, findIndex, isEmpty } from 'lodash';
import MatchdayStatus from '../manage-team/Matchday-Status';

class UpcomingFixturesPopup extends Component {
    constructor(props, context) {
        super(props, context);
        this.closePopup = this.closePopup.bind(this);
        this.state = {
            displayFixtures: {},
            responseData: {},
            userSpecificFixtures: [],
            isDDOpen: false,
            currentActiveFixture: 0,
            teamlock: null
        };
    }

    setCommonState(nextProps) {
        // let playerCardDetails = nextProps.playerCardDetails;
        let isFixturePopupVisible = nextProps.isFixturePopupVisible;
        let trans = nextProps.trans;
        this.setState({ isFixturePopupVisible, trans });
    }

    componentDidMount() {
        if (this.props.fixtures.length) {
            this.processFixtureData(this.props.fixtures);
        } else {
            this.props.getFixtures().then(() => {
                const { fixtures } = this.props;
                this.processFixtureData(fixtures);
            });
        }
    }

    checkUpcomingMatch(gd) {
        let hasUpcoming = false;
        if (gd) {
            const matches = gd.Match || [];
            for (let i = 0; i < matches.length; i++) {
                if (+matches[i].MatchStatus === 0) {
                    hasUpcoming = true;
                    break;
                }
            }
        }
        return hasUpcoming;
    }

    processFixtureData(fixtures) {
        let endOfTournament = false;
        const userSpecificFixtures = getFixturesToPrintForMatches(fixtures);
        const defaultIndex = findIndex(userSpecificFixtures, { selected: true });
        let selectedGameDay = userSpecificFixtures[defaultIndex];
        // const currentGD = find(userSpecificFixtures, { selected: true });
        // let selectedGameDay = currentGD;
        const hasCurrentGDUpcoming = this.checkUpcomingMatch(selectedGameDay);
        if (!hasCurrentGDUpcoming) {
            const upcomingGD = find(userSpecificFixtures, { status: 1 });
            if (upcomingGD) {
                selectedGameDay = upcomingGD;
            } else {
                endOfTournament = true;
            }
        }
        const groupByMatches = this.createFixtureGroups(selectedGameDay);
        this.setState({
            userSpecificFixtures,
            displayFixtures: groupByMatches.group,
            endOfTournament: endOfTournament,
            currentActiveFixture: defaultIndex
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setCommonState(nextProps);
    }

    closePopup = (e) => {
        let bodyElem = document.body;
        bodyElem.classList.remove('bodyNoScroll');
        this.props.triggerHandleFixturePopup(false);

    };
    setInitialState = () => {
        this.setState({
            responseData: {},
            userSpecificFixtures: [],
        });
    };

    componentWillMount() {
        this.setInitialState();
    }

    // createFixtureGroups = (gameday) => {
    //     const { trans, constraints } = this.props;
    //     let obj = {
    //         group: {}
    //     };
    //     for (var i = 0; i < gameday.Match.length; i++) {
    //         let match = gameday.Match[i];
    //         let MDNo = match.MDNo;
    //         if (!obj.group[MDNo]) {
    //             // match.DateTime = '2018-08-08 20:45';
    //             obj.group[MDNo] = {
    //                 date: getMatchTimeObj(match.DateTime, trans, constraints.OffSet),
    //                 matches: []
    //             }
    //         }
    //         if (+match.MatchStatus === 0) {
    //             obj.group[MDNo].matches.push(match);
    //         }
    //     }
    //     return obj;
    // }

    createFixtureGroups = (gameday) => {
        const { trans, constraints } = this.props;
        let obj = {
            group: {},
            lockTime: ''
        };
        for (let i = 0; i < gameday.Match.length; i++) {
            let match = gameday.Match[i];
            let MDNo = match.MDNo;
            if (!obj.group[MDNo]) {
                // match.DateTime = '2018-08-08 20:45';
                obj.group[MDNo] = {
                    date: getMatchTimeObj(match.DateTime, trans, constraints.OffSet),
                    subsWindow: {
                        isAvailable: false
                    },
                    matches: []
                };
                if (match.TeamSc) {
                    obj.group[MDNo]["subsWindow"]["isAvailable"] = (match.TeamSc === "UT_SUB");
                    obj.group[MDNo]["subsWindow"]["TeamScStartDate"] = match.TeamScStartDate;
                    obj.group[MDNo]["subsWindow"]["TeamScEndDate"] = match.TeamScEndDate;
                    if (match.TeamSc === "UT_TRF") {
                        obj.lockTime = match.TeamScEndDate;
                    }
                }
            }
            obj.group[MDNo].matches.push(match);
        }
        return obj;
    };

    onMatchClick = (e, matchId, MStatus) => {
        e.stopPropagation();
        if (+MStatus === config.enumMatchStatus.isLock) {
            //update buster
            common.updateBusters('/matchdetails');
        }

        return this.props.history.push('/matchdetails/' + matchId + "/" + MStatus);
    };
    onDDTap = (e) => {
        this.setState(prevState => ({
            isDDOpen: !prevState.isDDOpen,
        }));
    };
    onPreviousTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: --currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onNextTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: ++currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onSelect = (currentActiveFixture, e) => {
        e.stopPropagation();
        this.setState({ currentActiveFixture, isDDOpen: !this.state.isDDOpen });
        this.pageNumber = 1;
        this.getRespectiveData(currentActiveFixture);
    };
    getRespectiveData = (currentActiveFixture) => {
        const { userSpecificFixtures } = this.state;
        const selectedGameDay = userSpecificFixtures[currentActiveFixture];
        this.checkForLiveScoring(selectedGameDay);
        const groupByMatches = this.createFixtureGroups(selectedGameDay);
        this.setState({ displayFixtures: groupByMatches.group, teamlock: groupByMatches.lockTime });
    };
    startInterval = (Deadline, OffSet, MixApiFixtureStatus) => {
        if (MixApiFixtureStatus !== config.fixtureStatus.isLock) {
            common.getDiffWithCurrentTimeInMinutes(Deadline, OffSet, (diffInMins) => {
                if (diffInMins > config.TIME_DIFF_TO_CONSIDER) {
                    if (diffInMins < config.MIXED_API_INTERVAL_START_TIME) {
                        this.timeout_mix = setTimeout(this.hitMixAPi, 1000 * config.MIXED_API_INTERVAL_DURATION);
                    } else {
                        this.timeout_local = setTimeout(() => {
                            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
                        }, 1000 * config.MIXED_API_BEFORE_INTERVAL_DURATION);
                    }
                }
            });
        }
    };
    hitMixAPi = () => {
        let self = this;
        this.props.triggerMixFetchData().then(() => {
            const mixedResponse = self.props.mixResponse;
            const { OffSet } = self.props.constraints;
            let { Deadline, Fixture } = mixedResponse;
            const MixApiFixtureStatus = getFixtureStatus(Fixture || {});
            if (Fixture !== null) {
                const { userSpecificFixtures, currentActiveFixture } = self.state;
                const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
                const gamedayId = currentFixture['GDID'];
                if (+gamedayId === +Fixture['GDID']) {
                    const userFixtureStatus = currentFixture.status;
                    if (userFixtureStatus !== MixApiFixtureStatus) {
                        common.updateBusters('/bust-after-status-change');
                        return self.init();
                    }
                }
            }
            self.startInterval(Deadline, OffSet, MixApiFixtureStatus);
        });
    };
    callLiveAPI = () => {
        this.props.triggerLiveScoreFetchData().then(() => {
            this.timeout_live = setTimeout(() => {
                this.hitMixAPi();
                this.callLiveAPI();
            }, 1000 * config.MIXED_API_INTERVAL_DURATION);
        });
    };
    clearAllTimeout = () => {
        clearTimeout(this.timeout_mix);
        clearTimeout(this.timeout_local);
        clearTimeout(this.timeout_live);
    };
    checkForLiveScoring = (selectedGameDay) => {
        this.clearAllTimeout();
        if (selectedGameDay.status === config.fixtureStatus.isLock) {
            this.callLiveAPI();
        } else if (selectedGameDay.status !== config.fixtureStatus.isFinished) {
            this.hitMixAPi();
        }
    };

    init = () => {
        const { fixtures } = this.props;
        const userSpecificFixtures = getFixturesToPrintForMatches(fixtures);
        const defaultIndex = findIndex(userSpecificFixtures, { selected: true });
        const selectedGameDay = userSpecificFixtures[defaultIndex];
        this.checkForLiveScoring(selectedGameDay);
        const groupByMatches = this.createFixtureGroups(selectedGameDay);
        this.setState({
            userSpecificFixtures,
            displayFixtures: groupByMatches.group,
            teamlock: groupByMatches.lockTime,
            currentActiveFixture: defaultIndex,
        });
    };


    render() {
        let self = this;
        const { displayFixtures, userSpecificFixtures, endOfTournament, currentActiveFixture, teamlock, isDDOpen } = self.state;
        const { isFixturePopupVisible, constraints, trans } = self.props;
        const isFixtureUpdated = (constraints.IsFixtureUpdated === 1 || constraints.IsFixtureUpdated === "1");
        if (userSpecificFixtures.length === 0) return null;
        let bodyElem = document.body;
        if (!isFixturePopupVisible) {
            bodyElem.classList.remove('bodyNoScroll');
            return null;
        } else {
            bodyElem.classList.add('bodyNoScroll');
        }

        if (userSpecificFixtures.length === 0) return null;
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
        const selectedLabel = trans['rd' + selectedMatchDay.GDID];
        const isFirst = currentActiveFixture === 0;
        const isLast = currentActiveFixture === (userSpecificFixtures.length - 1);
        const prevBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_right': true,
            'si-disabled': isFirst
        });
        const nextBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_left': true,
            'si-disabled': isLast
        });

        return <div id={ "upcomingFixturesModal" }>
            <div className="si-modal-wrap">
                <div className="si-full-width">

                    <div className="si-common-popup si-fixture-popup">
                        <OutsideNotifier handler={ this.closePopup }>
                            <div className="si-fixture-header">
                                <span>{ trans.fixtures }</span>
                                <i className="si-close icon-ucl-close" onClick={ this.closePopup } />
                            </div>
                            {
                                endOfTournament ?
                                    <div className="si-no-fixture-wrap">
                                        <i className="icon-ucl-warning-icon" />
                                        <div className="si-txt">{ trans.endOfTournament }</div>
                                    </div> :
                                    isFixtureUpdated ?
                                        <div className="si-fixture-wrap">
                                            <Scrollbars autoHide>
                                                {
                                                    isFixtureUpdated ? <div className="si-selectbox">
                                                        <div className="si-dropdown-btn">
                                                            <i className={ prevBtnClasses } onClick={ () => this.onPreviousTap() } />
                                                            <span onClick={ (e) => this.onDDTap(e) }>{ selectedLabel }</span>
                                                            <i className={ nextBtnClasses } onClick={ () => this.onNextTap() } />
                                                        </div>

                                                        <ul className={ "si-dropdown-options " + (isDDOpen ? "" : "si-hidden") }>
                                                            { userSpecificFixtures.map((el, index) => {
                                                                const selectedLabel = trans['rd' + el.GDID];
                                                                const isSelected = currentActiveFixture === index ? 'si-selected' : '';
                                                                return <li key={ index } className={ isSelected }
                                                                    onClick={ (e) => this.onSelect(index, e) }>
                                                                    <span>{ selectedLabel }</span></li>
                                                            }) }
                                                        </ul>

                                                    </div> : null
                                                }

                                                { isFixtureUpdated ? <MatchdayStatus deadline={ teamlock } /> : null }

                                                {
                                                    Object.keys(displayFixtures).map(function (key, index) {
                                                        let day = displayFixtures[key].date.dateDay;
                                                        let boxMatches = displayFixtures[key].matches;
                                                        return ((boxMatches.length > 0) ? <div key={ index }>
                                                            <div className="si-fixture-box">
                                                                <div className="si-fixture-head">
                                                                    <span>{ day }</span>
                                                                </div>
                                                                <ul className="si-teamList-wrap">
                                                                    {
                                                                        boxMatches.map(function (match, index) {
                                                                            let matchId = match.MID;
                                                                            let matchDate = getMatchTimeObj(match.DateTime, trans, constraints.OffSet);
                                                                            let HTImg = config.UEFAImgBase + `teams/logos/140x140/${match.HTID}.png`;
                                                                            let ATImg = config.UEFAImgBase + `teams/logos/140x140/${match.ATID}.png`;
                                                                            let MStatus = match.MatchStatus;
                                                                            let matchClickHandler = {
                                                                                onClick: () => {
                                                                                }
                                                                            };
                                                                            let matchClassesObj = {
                                                                                'si-teamList-teamInfo-fBox': true
                                                                            }
                                                                            let teamListStatus = matchDate.matchTime;
                                                                            if (MStatus === "3") { //post
                                                                                matchClassesObj["si-matCompleted"] = true;
                                                                                teamListStatus = (match.HTScr ? match.HTScr : '') + ' - ' + (match.ATScr ? match.ATScr : '');
                                                                                matchClickHandler = { onClick: (e) => self.onMatchClick(e, match) };
                                                                            } else if (MStatus === "1" || MStatus === "2") { //live
                                                                                if (MStatus === "1") {
                                                                                    matchClassesObj["si-matLiv"] = true;
                                                                                } else {
                                                                                    matchClassesObj["si-matLiv"] = false;
                                                                                }

                                                                                teamListStatus = (match.HTScr ? match.HTScr : '') + ' - ' + (match.ATScr ? match.ATScr : '');
                                                                                matchClickHandler = { onClick: (e) => self.onMatchClick(e, match) };
                                                                            } else if (MStatus === "0") { //pre
                                                                                // teamListStatus = trans.postponed ? trans.postponed : "Postponed";
                                                                                matchClassesObj["si-matUpcoming"] = true;
                                                                            } else { //pre
                                                                                // teamListStatus = trans.postponed ? trans.postponed : "Postponed";
                                                                                matchClassesObj["si-matUpcoming"] = true;
                                                                            }
                                                                            let matchClasses = common.makeClasses(matchClassesObj);
                                                                            return <li key={ matchId } { ...matchClickHandler }>
                                                                                <div className={ matchClasses }>
                                                                                    <div
                                                                                        className="si-teamList-teamInfo-fItem si-teamInfo-teamA">
                                                                                        <div className="si-teamInfo-fBox">
                                                                                            <div
                                                                                                className="si-teamInfo-plyName">
                                                                                                <div
                                                                                                    className="si-fullName">
                                                                                                    <span>{ match.HTName }</span>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="si-shortName">
                                                                                                    <span>{ match.HTSName }</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="si-teamInfo-plyThumb"
                                                                                                style={ { backgroundImage: "url(" + HTImg + ")" } } />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="si-teamList-teamInfo-fItem si-teamInfo-vs">
                                                                                        <div className="si-teamList-status">
                                                                                            <span>{ teamListStatus }</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="si-teamList-teamInfo-fItem si-teamInfo-teamB">
                                                                                        <div
                                                                                            className="si-teamInfo-fBox si-flexBox-reverse">
                                                                                            <div
                                                                                                className="si-teamInfo-plyName">
                                                                                                <div
                                                                                                    className="si-fullName">
                                                                                                    <span>{ match.ATName }</span>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="si-shortName">
                                                                                                    <span>{ match.ATSName }</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="si-teamInfo-plyThumb"
                                                                                                style={ { backgroundImage: "url(" + ATImg + ")" } } />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div> : null)
                                                    })
                                                }
                                            </Scrollbars>
                                        </div> :
                                        <div className="si-no-fixture-wrap">
                                            <i className="icon-ucl-warning-icon" />
                                            <div className="si-txt">{ trans.noFixture }</div>
                                        </div>
                            }
                        </OutsideNotifier>
                    </div>

                </div>
            </div>
        </div>
    }
}

const mapSateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        fixtures: state.formationData.fixtures,
        mixResponse: state.formationData.mixResponse,
        isFixturePopupVisible: state.formationData.isFixturePopupVisible,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getFixtures: (GamedayId) => dispatch(getFixtures(GamedayId)),
        triggerHandleFixturePopup: (isFixturePopupVisible) => dispatch(triggerHandleFixturePopup(isFixturePopupVisible)),
        triggerMixFetchData: () => dispatch(triggerMixFetchData()),
    };
};
export default connect(mapSateToProps, mapDispatchToProps)(UpcomingFixturesPopup);


// WEBPACK FOOTER //
// ./src/components/matches/upcomingFixturesPopup.js